export default {
  name: 'icon-arrow-right'
};